/** Return a Teams model that has even teams (doesnt care about wantsToJoinTeam property) */
export function buildTeamsFromClientBuddies(combatants={}) {

  let teamOneCombatantIds = [];
  let teamTwoCombatantIds = [];

  //Identify the humans
  const humanKeys = Object.keys(combatants).filter(comb => {
    const model = combatants[comb];
    return !model.isBot && !model.isBuddy
  });

  if (humanKeys[0]) {
    teamOneCombatantIds.push(humanKeys[0]);
  }
  if (humanKeys[1]) {
    teamTwoCombatantIds.push(humanKeys[1]);
  }


  //Sort into two teams
  Object.keys(combatants).forEach((combId, i) => {

    //If it's a Buddy, look at their belongsToClient property.
    const model = combatants[combId];

    if (model && model.isBuddy) {
      if (model.belongsToClient === humanKeys[0]) {
        teamOneCombatantIds.push(combId);
      }
      if (model.belongsToClient === humanKeys[1]) {
        teamTwoCombatantIds.push(combId);
      }
    }
  });

  return {
      "one": {
        combatantIds: teamOneCombatantIds,
      },
      "two": {
        combatantIds: teamTwoCombatantIds,
      }
  }
}


// WEBPACK FOOTER //
// ./src/battle/lifecycle/build-teams-from-client-buddies.js